
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/mention",
      function () {
        return require("private-next-pages/info/mention.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/mention"])
      });
    }
  